import React from 'react';
import { Form, Input, Select } from 'antd';

const { Option } = Select;

const OutputNodeProperties = ({ config, nodeType }) => {
  if (nodeType === 'dataset_output') {
    return (
      <>
        <Form.Item label="Output Filename" name="filename" initialValue={config.filename || 'output'}>
          <Input placeholder="output" />
        </Form.Item>
        <Form.Item label="Format" name="format" initialValue={config.format || 'csv'}>
          <Select>
            <Option value="csv">CSV</Option>
            <Option value="json">JSON</Option>
            <Option value="excel">Excel</Option>
          </Select>
        </Form.Item>
      </>
    );
  }

  if (nodeType === 'chart_output') {
    return (
      <>
        <Form.Item label="Chart Type" name="chartType" initialValue={config.chartType || 'line'}>
          <Select>
            <Option value="line">Line Chart</Option>
            <Option value="bar">Bar Chart</Option>
            <Option value="pie">Pie Chart</Option>
            <Option value="scatter">Scatter Plot</Option>
          </Select>
        </Form.Item>
        <Form.Item label="X Axis" name="xAxis" initialValue={config.xAxis}>
          <Input placeholder="Column for X axis" />
        </Form.Item>
        <Form.Item label="Y Axis" name="yAxis" initialValue={config.yAxis}>
          <Input placeholder="Column for Y axis" />
        </Form.Item>
      </>
    );
  }

  return null;
};

export default OutputNodeProperties;